module.exports = __webpack_public_path__ + "img/Ellipsis.50949bd0.gif";